import * as React from 'react';

import { hasA11yProp } from '../icons/hasA11yProp';
import { ICON_MARKER } from '../icons/iconMarker';

export type DotProps = {
    /** The dot's color: a CSS color, such as a `colorSystem` value. */
    color: string;
    /** The box's width and height in px; the dot is two thirds of it. Slots that size icons override it. */
    size?: number;
} & Omit<React.SVGProps<SVGSVGElement>, 'color' | 'ref' | 'width' | 'height' | 'viewBox' | 'fill'>;

/** A status dot, sized and placed like an icon; `stroke` and `strokeWidth` (view-box units) draw a ring around it. */
export const Dot = React.forwardRef<SVGSVGElement, DotProps>(function Dot({ color, size = 9, style, ...props }, ref) {
    return (
        <svg
            ref={ref}
            {...ICON_MARKER}
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            aria-hidden={hasA11yProp(props) ? undefined : 'true'}
            {...props}
            style={{ flexShrink: 0, color, ...style }}
        >
            <circle cx="12" cy="12" r="8" fill="currentColor" />
        </svg>
    );
});
